import { gql } from "apollo-boost";

export const GET_BANKS = gql `
query Query($limit: Int, $orderBy: OrderByInput, $where: BankWhereInput) {
    banks(limit: $limit, orderBy: $orderBy, where: $where) {
      total
      data {
        id
        image
        bankName
        bankAccount
        bankUser
        shop {
          name
        }
        isActiveDefault
        createdAt
        updatedAt
      }
    }
  }
`
